import React, { useEffect, useState } from 'react'

import EventEmitter from 'mitt'
import {
  getAllSuppliers,
  getAllSuppliersWithContacts,
} from 'src/services/requests/supplierContacts/suppliers'
import { getTenderChapters } from 'src/services/requests/tenders/tenders'
import { label } from 'aws-amplify'

export const GlobalVariablesContext = React.createContext({})
export const GlobalVariablesContextProvider = GlobalVariablesContext.Provider
export const errorEventEmitter = new EventEmitter()

const GlobalVariablesContextWrapper = (props) => {
  const [forceUsername, setForceUsername] = useState('')
  const [forcePassword, setForcePassword] = useState('')
  const [error, setError] = useState()
  const [errorMsg, setErrorMsg] = useState('')
  const [hash, setHash] = useState('')
  const [tenderId, setTenderId] = useState('')
  const [tenderName, setTenderName] = useState('')
  const [tenderChapters, setTenderChapters] = useState([])
  const [allSuppliers, setAllSuppliers] = useState([])
  const [allSuppliersWithContacts, setAllSuppliersWithContacts] = useState([])
  const [allSuppliersWithContactsOptions, setAllSuppliersWithContactsOptions] = useState([])
  const [suppliersLoaded, setSuppliersLoaded] = useState(false)

  useEffect(() => {
    //do not remove this console.log
    error ? console.log('there is error ' + error) : ''
  }, [error])

  useEffect(() => {
    const showError = () => {
      let array = window.localStorage.getItem('errors')
      array = array ? JSON.parse(array) : []
      let error = array.pop()
      window.localStorage.setItem('errors', JSON.stringify(array))
      setError(error)
      //clearing the error message after 3 sconds to avoid multiple error renders
      setTimeout(() => {
        setError(null)
      }, 3000)
    }

    errorEventEmitter.on('error', showError)

    return () => {
      errorEventEmitter.off('error', showError)
    }
  }, [])

  const fetchAllSuppliersWithContacts = async () => {
    setSuppliersLoaded(false)
    getAllSuppliersWithContacts()
      .then((result) => {
        result.data.totalRecords
          ? setAllSuppliersWithContacts(result.data.records.filter(supplier => supplier.active === "active"))
          : setAllSuppliersWithContacts([])
      })
      .catch(() => setSuppliersLoaded(true))
  }

  const fetchAllSuppliers = async () => {
    getAllSuppliers().then((result) => {
      result.data.totalRecords ? setAllSuppliers(result.data.records.filter(supplier => supplier.active === "active")) : setAllSuppliers([])
    })
  }

  const createAllSuppliersWithContactsOptions = () => {
    let suppliersWithContacts = []

    allSuppliersWithContacts?.forEach((supplierWithContacts) => {
      // let defaultContact = supplierWithContacts?.defaultContact // HERE
      //   ? [
      //       {
      //         value: supplierWithContacts.defaultContact.id,
      //         label: `${supplierWithContacts.contact.email} (${supplierWithContacts.companyName})`,
      //       },
      //     ]
      //   : []

      let defaultContact = []

      if(supplierWithContacts?.defaultContact) {
        let fullDefaultContact = supplierWithContacts.contacts.find(contact => contact.id === supplierWithContacts.defaultContact.id)
        if (fullDefaultContact)
          defaultContact = [
            {
              value: fullDefaultContact.id,
              label: `${fullDefaultContact.firstName || fullDefaultContact.lastName ?
                  `${fullDefaultContact.firstName} ${fullDefaultContact.lastName}`
                : fullDefaultContact.email} (${supplierWithContacts.companyName})`
            }
          ]
      }

      let supplierContacts = supplierWithContacts?.contacts
        ? supplierWithContacts.contacts
            .map((contact) => ({
              value: contact.id,
              label: `${contact.firstName} ${contact.lastName} (${supplierWithContacts.companyName})`,
            }))
            .filter((contact) => contact.value !== defaultContact[0]?.value)
        : []

      const preparedSupplierOptions = {
        label: supplierWithContacts.companyName,
        code: 'allSuppliers',
        options: [...defaultContact, ...supplierContacts],
      }

      if (preparedSupplierOptions.options.length > 0) {
        suppliersWithContacts.push(preparedSupplierOptions)
      }
    })

    setAllSuppliersWithContactsOptions(suppliersWithContacts)
    setSuppliersLoaded(true)
  }


  useEffect(() => {
    if (tenderId) {
      fetchAllSuppliersWithContacts()
      fetchAllSuppliers()
    }
  }, [tenderId])

  useEffect(() => {
    createAllSuppliersWithContactsOptions()
  }, [allSuppliersWithContacts])

  const fetchTenderChapters = (id) => {
    getTenderChapters(id).then((result) => {
      setTenderChapters(result.data)
    })
  }

  useEffect(() => {
    if (tenderId) fetchTenderChapters(tenderId)
  }, [tenderId])

  return (
    <GlobalVariablesContextProvider
      value={{
        forceUsername,
        setForceUsername,
        forcePassword,
        setForcePassword,
        setError,
        error,
        setErrorMsg,
        errorMsg,
        hash,
        setHash,
        tenderName,
        setTenderName,
        tenderId,
        setTenderId,
        tenderChapters,
        allSuppliers,
        allSuppliersWithContacts,
        allSuppliersWithContactsOptions,
        fetchAllSuppliersWithContacts,
        suppliersLoaded,
      }}
    >
      {props.children}
    </GlobalVariablesContextProvider>
  )
}
export default GlobalVariablesContextWrapper
